import { X } from 'lucide-react';

interface ReplyPreviewProps {
  senderName: string;
  content: string;
  onClear: () => void;
}

export function ReplyPreview({ senderName, content, onClear }: ReplyPreviewProps) {
  return (
    <div className="flex items-center gap-2.5 px-4 py-2 bg-muted/30">
      <div className="w-[3px] h-8 bg-primary rounded-full shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-[11px] font-semibold text-primary">{senderName}</p>
        <p className="text-[12px] text-muted-foreground/70 truncate leading-tight">{content}</p>
      </div>
      <button
        onClick={onClear}
        className="h-6 w-6 rounded-full flex items-center justify-center hover:bg-muted/60 transition-colors shrink-0"
      >
        <X className="h-3.5 w-3.5 text-muted-foreground/50" />
      </button>
    </div>
  );
}
